import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { senaSignup } from '../../api/senaApi';
import './SenaAuth.css';

export default function SenaSignup() {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [userName, setUserName] = useState('');
  const [passWd, setPassWd] = useState('');
  const [passWdConfirm, setPassWdConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!loginId || !userName || !passWd || !passWdConfirm) {
      setError('모든 항목을 입력해주세요.'); return;
    }
    if (passWd !== passWdConfirm) {
      setError('비밀번호가 일치하지 않습니다.'); return;
    }
    if (passWd.length < 4) {
      setError('비밀번호는 4자 이상이어야 합니다.'); return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await senaSignup(loginId, passWd, userName);
      alert(typeof res.data === 'string' ? res.data : '가입 요청이 접수되었습니다.');
      navigate('/sena/login');
    } catch (e) {
      const msg = e?.response?.data || '회원가입에 실패했습니다.';
      setError(typeof msg === 'string' ? msg : JSON.stringify(msg));
    } finally { setLoading(false); }
  };

  return (
    <div className="sena-page">
      <div className="sena-auth-container">
        <div className="sena-auth-card">
          <h1 className="sena-auth-title">회원가입</h1>
          <p className="sena-auth-sub">세나리 추력 길드</p>

          <form onSubmit={handleSignup} className="sena-auth-form">
            <div className="sena-auth-field">
              <label>아이디</label>
              <input type="text" value={loginId} onChange={e => setLoginId(e.target.value)}
                placeholder="아이디 입력" autoFocus />
            </div>
            <div className="sena-auth-field">
              <label>닉네임 (세나닉)</label>
              <input type="text" value={userName} onChange={e => setUserName(e.target.value)}
                placeholder="게임 내 닉네임" />
            </div>
            <div className="sena-auth-field">
              <label>비밀번호</label>
              <input type="password" value={passWd} onChange={e => setPassWd(e.target.value)}
                placeholder="비밀번호 입력" />
            </div>
            <div className="sena-auth-field">
              <label>비밀번호 확인</label>
              <input type="password" value={passWdConfirm} onChange={e => setPassWdConfirm(e.target.value)}
                placeholder="비밀번호 다시 입력" />
            </div>

            {error && <p className="sena-auth-error">{error}</p>}

            <button type="submit" className="sena-auth-btn" disabled={loading}>
              {loading ? '가입 요청 중...' : '가입 요청'}
            </button>
          </form>

          <p className="sena-auth-link">
            이미 계정이 있으신가요? <button onClick={() => navigate('/sena/login')}>로그인</button>
          </p>
          <p className="sena-auth-link">
            <button onClick={() => navigate('/sena')}>← 메인으로</button>
          </p>
        </div>
      </div>
    </div>
  );
}
